import useAuth from 'hooks/use-auth'
import useAgent from 'hooks/use-agent'
import {
  getFirstAttackAsStep,
  getScenarioStepCount
} from 'components/scenarios/utils'

export default function useScenarioScheduleDetails(scenarioId) {
  const { currentTeamId } = useAuth()
  const { data: scenario } = useAgent(
    `/scenarios/${scenarioId}?teamId=${currentTeamId}`,
    {},
    { shouldCache: true }
  )

  const { impactDefinition = {}, targetDefinition } =
    getFirstAttackAsStep(scenario) ?? {}

  const targetParams = Object.assign(
    targetDefinition?.strategy?.tags ?? {},
    targetDefinition?.strategy?.multiSelectTags ?? {},
    targetDefinition?.strategy?.labels ?? {},
    targetDefinition?.strategy?.multiSelectLabels ?? {}
  )
  const targetParamsList = Object.entries(targetParams)

  return {
    name: scenario.name,
    commandType: impactDefinition.commandType,
    stepCount: getScenarioStepCount(scenario),
    targetParams,
    additionalTargetParamsAmount:
      targetParamsList.length > 1 ? targetParamsList.length - 1 : null,
    firstTargetParam: targetParamsList[0],
    targetDefinition
  }
}
